import { Controller } from 'stimulus';
import { initializeNestedNarrativeList } from "../packs/narratives";

export default class extends Controller {
  connect(){
    var collection_fields = ["#narrative_topic_list", "#issue_tags_list", "#issue_organization_ids"]

    collection_fields.forEach(function(id){ 
      $(id).on('select2:select', function () {
        let event = new Event('change', { bubbles: true }) 
        this.dispatchEvent(event);
      });
  
      $(id).on('select2:unselect', function () {
        let event = new Event('change', { bubbles: true }) 
        this.dispatchEvent(event);
      });
    })
    
  }

  beforeFilter() {
    this.progressBar = new Turbolinks.ProgressBar();
    this.progressBar.setValue(0);
    this.progressBar.show();
  }

  afterFilter() {
    this.progressBar.setValue(1);
    this.progressBar.hide();
  }

  sendFilterAjaxCall(url, data) {
    Rails.ajax({
      type: 'GET',
      url: url,
      data: data,
      success: (response) => {
        $("body").html($(response.body));
        this.afterFilter();
      }
    });
  }

  sendNarrativeFilterCall(url, data) {
    Rails.ajax({
      type: 'GET',
      url: url,
      data: data,
      dataType: 'json',
      success: (response) => {
        $("#narratives-list-sortable").html(response)
        initializeNestedNarrativeList();
      }
    });
  }

  sendIssueFilterCall(url, data) {
    Rails.ajax({
      type: 'GET',
      url: url,
      data: data,
      dataType: 'json',
      success: (response) => {
        $("#issue-list-sortable").html(response)
      }
    });
  }

  setTopicsFilter(){
    var checked = this.checkedList('topic-dropdown-filter');
    let params = new URLSearchParams(window.location.search)
    var parameter_name = 'topics[]'

    params.delete(parameter_name)
    checked.map(function(value) {
      params = params +`&${parameter_name}=`+value ;
    });
    window.location.href = window.location.href.split('?')[0] + '?' + params
  }

  checkedList(listContainerCLass) {
    var checked = [];
    $(`.${listContainerCLass}:checked`).each(function() {
      if($(this).attr('id') != undefined) {
        var id = $(this).attr('id').replace("list-", "");
        checked.push(id);
      }
    })
    return checked;
  }

  searchQuery(event) {
    // event.preventDefault();
    if ($(event.target).attr("action") != undefined) {
      this.beforeFilter();
      var url = $(event.target).attr("action");
      var currentParams = this.getSearchParams();
      var keyword = $("#keyword").val();
      currentParams["keyword"] = keyword;
      if(keyword == null || keyword == '') delete currentParams["keyword"];
      var data = $.param(currentParams);
      url += "?" + data;
      window.history.pushState({ turbolinks: true, url: url }, '', url);
      this.sendFilterAjaxCall(url, data);
    } else {
      let url = new URL(window.location.href);
      var keyword = $("#keyword").val();
      url.searchParams.set('keyword', keyword)
      if(keyword == null || keyword == '') { url.searchParams.delete("keyword") };
      window.location.href = url.href;
    }
  }

  searchNarratives(event){
    event.preventDefault();
    var url = $(event.target).attr("action");
    var keyword = $("#narratives_keyword").val();
    var currentParams = this.getSearchParams();
    currentParams["keyword"] = keyword;
    currentParams["filter_type"] = "narratives";
    var data = $.param(currentParams);

    this.sendNarrativeFilterCall(url, data);
  }

  filterByTopic(event){
    var url = "/narratives/assign_issues";
    var currentParams = this.getSearchParams();
    
    currentParams["topics"] = $("#narrative_topic_list").val();
    currentParams["filter_type"] = "narratives";
    var data = $.param(currentParams);

    this.sendNarrativeFilterCall(url, data);
  }
  
  searchIssues(event){
    event.preventDefault();
    var url = $(event.target).attr("action");
    var currentParams = this.getSearchParams();
    var keyword = $("#issues_keyword").val();
    currentParams["q"] = keyword;
    currentParams["filter_type"] = "issues";
    var data = $.param(currentParams);

    this.sendIssueFilterCall(url, data);
  }

  filterIssues(event){
    var url = "/narratives/assign_issues";
    var currentParams = this.getSearchParams();
    currentParams["filter_type"] = "issues";

    if($(event.target).data("type") == "tags"){
      currentParams["tags"] = $(event.target).val();
    } else if ($(event.target).data("type") == "organization") {
      currentParams["organization_ids"] = $(event.target).val();
    } else if ($(event.target).data("type") == "needs_narrative") {
      currentParams["has_no_narratives"] = ($(event.target).prop('checked')) ? "1" : "0";
    }
    var data = $.param(currentParams);

    this.sendIssueFilterCall(url, data);
  }

  getSearchParams() {
    var url = new URL(window.location.href);
    var search = new URLSearchParams(url.search);
    let paramObj = {};
    for(var value of search.keys()) {
        paramObj[value] = search.get(value);
    }
    return paramObj;
  }
}
